/// <amd-module name="typeahead/core/geolocation/logging/GeolocationMetricLogger" />
import {IPosition, IPositionError} from "typeahead/core/geolocation/GeolocationDataProvider";
import {GeolocationMetric} from "typeahead/core/geolocation/logging/GeolocationMetric";
import {GeolocationRequestMessage} from "typeahead/core/geolocation/message/GeolocationRequestMessage";
import {GeolocationResponseMessage} from "typeahead/core/geolocation/message/GeolocationResponseMessage";
import {CollectorTransport} from "typeahead/core/logging/CollectorTransport";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import {Lob, TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class GeolocationMetricLogger {

    private lob: string;
    private beginTimestamp: number;
    private endTimestamp: number;
    private position: IPosition;
    private positionError: IPositionError;
    private domElementId: string;

    constructor() {
        TypeaheadMessage.subscribe(
            GeolocationRequestMessage.getTopic(), (topic: string, message: GeolocationRequestMessage) => {
                this.lob = Lob[TypeaheadUtils.getLob()];
                this.domElementId = message.getDomElementId();
                this.beginTimestamp = Date.now();
            },
        );
        TypeaheadMessage.subscribe(
            GeolocationResponseMessage.getTopic(), (topic: string, message: GeolocationResponseMessage) => {
                this.position = message.getPosition();
                this.positionError = message.getPositionError();
                this.endTimestamp = Date.now();
                this.emitGeolocationMetric();
            },
        );
    }

    private emitGeolocationMetric(): void {
        new CollectorTransport().log(new GeolocationMetric(
            Lob[TypeaheadUtils.getLob()],
            this.domElementId,
            this.beginTimestamp,
            this.endTimestamp,
            this.position,
            this.positionError,
            undefined), "typeahead_client_metrics");
    }
}
